import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Icon } from '../icon/Icon';
import { neutrals } from 'src/theme/colors';
import { IconName } from '../icon/icon.helper';
import TextLato from '../text/text-lato/TextLato';
import { TextAlignment } from 'src/constants/font.constants';
import { generateTestID, generateSelectedTestID } from 'src/helpers/testIDs.helper';
import { TestIDs } from 'src/constants/testIDs.constants';

export default function Alignment({
  label = '',
  options = [],
  selected,
  onSelect,
  testID,
}: {
  label: string;
  options: { key: TextAlignment; icon: IconName }[];
  selected: string;
  onSelect: (value: TextAlignment) => void;
  testID?: string;
}) {
  return (
    <View style={styles.container} testID={testID}>
      <TextLato style={styles.label}>{label}</TextLato>
      <View style={styles.selector}>
        {options.map((opt, index) => {
          const optionTestID = generateSelectedTestID(
            generateTestID(testID, `${TestIDs.ALIGNMENT_OPTION}${index}`),
            selected === opt.key,
          );
          return (
            <TouchableOpacity
              testID={optionTestID}
              key={`${TestIDs.ALIGNMENT_OPTION}${opt.key}`}
              style={[styles.button, selected === opt.key && styles.buttonActive]}
              onPress={() => onSelect(opt.key)}
            >
              <Icon
                name={opt.icon}
                width={24}
                height={24}
                color={selected === opt.key ? neutrals.white : neutrals.black}
              />
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'flex-start',
  },
  label: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 8,
  },
  selector: {
    flexDirection: 'row',
    backgroundColor: '#f4f4f4',
    borderRadius: 10,
    overflow: 'hidden',
  },
  button: {
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  buttonActive: {
    backgroundColor: '#3aa6a6',
  },
});
